import { graphql } from "@/gql";

export const GET_ME = graphql(`
  query GetMe {
    me {
      id
      email
      fullName
      role
      mayCreateSeries
    }
  }
`);
